import { useTuto } from './useTuto';
import { BandeauTuto } from './BandeauTuto';
import { VisiteTuto } from './VisiteTuto';

/**
 * Le tuto (tickets 31 et 33, découpé en parties au ticket 11 de retours-testeurs) : la visite
 * façon jeu, ou le bandeau du bas. Le serveur dit lequel des deux montrer ; rien quand le
 * tuto est fermé ou fini.
 */
export function Tuto() {
  const tuto = useTuto();
  const vue = tuto.data?.tuto ?? null;
  if (!vue) return null;
  if (vue.phase === 'visite') {
    return <VisiteTuto vue={vue} enCours={tuto.isFetching || tuto.isPlaceholderData} />;
  }
  return <BandeauTuto vue={vue} />;
}
